import aboutLearn from '../assets/aboutLearn.svg';
import aboutFlashcard from '../assets/aboutFlashcard.svg';
import aboutReward from '../assets/aboutReward.svg';
import GooglePlayBadge from "../components/GooglePlayBadge";
import AppleStoreBadge from "../components/AppleStoreBadge";
import SEO from "../components/SEO";

const About = () => {
  return (
    <>
      <SEO
        title="About Vespid - Gamified Financial Education Platform Malaysia"
        description="Discover Vespid, Malaysia's innovative gamified financial literacy platform. Learn about our mission to make personal finance education accessible through bite-sized content, quizzes, and rewards. Featured on Vulcan Post and BFM."
        keywords="about vespid, financial education platform Malaysia, personal finance learning, gamified education, financial literacy app Malaysia, investment education, budgeting education"
        url="/about"
      />
      <div className="max-w-screen-xl lg:mx-auto my-10 px-8 font-primaryFont font-light">
      <div className=" flex flex-col justify-center items-center">
        <h1 className="text-4xl font-bold text-center">
          A gamified personal finance learning mobile app platform.
        </h1>
        <div className="flex flex-row my-6">
          <GooglePlayBadge className="w-48" />
          <AppleStoreBadge className="w-48 ml-4" />
        </div>
      </div>
      <div className="mt-20 flex flex-col md:flex-row md:justify-center items-center">
        <img
          src={aboutLearn}
          alt="Vespid financial topics"
          loading="lazy"
          className="md:w-1/3 md:object-cover"
        />
        <div className="mt-4 md:w-1/2 md:px-4">
          <h2 className="text-3xl text-center">
            Consolidated platform for all personal finance related topics
          </h2>
          <p className="text-xl mt-2 font-light text-center">
            Vespid has simplistic app design and intuitive user experience for
            beginner and experienced users.
          </p>
        </div>
      </div>
      <div className="mt-10 flex flex-col md:flex-row-reverse md:justify-center items-center">
        <img
          src={aboutFlashcard}
          alt="Vespid financial topics"
          loading="lazy"
          className="md:w-1/3 md:object-cover"
        />
        <div className="md:w-1/2 mt-4 md:px-20">
          <h2 className="text-3xl text-center">
            Simplified, multilingual and gamified learning process
          </h2>
          <p className="text-xl mt-2 font-light text-center">
            Learn personal finance with bite-sized content, quizzes, leaderboard, and rewards.
          </p>
        </div>
      </div>
      <div className="mt-10 flex flex-col md:flex-row md:justify-center items-center">
        <img
          src={aboutReward}
          alt="Vespid financial topics"
          loading="lazy"
          className="md:w-1/3 md:object-cover"
        />
        <div className="md:w-1/2 mt-4 md:px-20">
          <h2 className="text-3xl text-center">
            Complete quizzes to qualify for rewards and rebates
          </h2>
          <p className="text-xl mt-2 font-light text-center">
            Redeem rewards and rebates directly in the app upon completing quizzes and challenges.
          </p>
        </div>
      </div>
      </div>
    </>
  );
};export default About;
